import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { Routes, Route } from 'react-router-dom';

import Loading from '../component/Loading';
import ErrorPage from '../component/ErrorPage';
import WrapperComponent from '../component/WrapperComponent';
import { useGetCompanyLogo, useGetTheme } from "../react-query/general";

import { routes } from './Routes';

const routesItem = [...routes];

export default function Routing() {
  const { companyLogo } = useGetCompanyLogo();
  const { theme } = useGetTheme();

  // Set theme color
  if (theme) {
    document.documentElement.style.setProperty('--bg-color', theme?.background_color);
    document.documentElement.style.setProperty('--primary-color', theme?.primary_color);
    document.documentElement.style.setProperty('--login-banner', `url(${theme?.file_path_banner})`);
  }

  return (
    <Router>
      <WrapperComponent> 
      <ErrorBoundary fallback={<ErrorPage />}>
        <Suspense fallback={<Loading companyLogo={companyLogo} />}>
          <Routes>
            {routesItem.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={route.element}
                exact={true}
              />
            ))}
          </Routes>
        </Suspense>
      </ErrorBoundary>
      </WrapperComponent> 
    </Router>
  );
}
